<div class="container-fluid">
  <app-landing-nav></app-landing-nav>
  <div class="container">
    <div class="plain_section wrap" style="padding-bottom: 0;">
      <div class="left">
        <h1
          class="section_header"
          data-aos="fade-in"
          data-aos-easing="ease-in-sine"
          data-aos-delay="200"
          data-aos-duration="1000"
        >
          All Of Your Payment Experience In One Suite
        </h1>

        <div class="section_sub_header">
          <!-- Accelerex Integrator seeks to provide businesses with a simplified
          payment plant. It provides you with an all-in-one platform designed to
          connect you with all our APIs in a secure and centralized platform. -->
          <br />
          <div
            class="get_started col-md-4"
            [routerLink]="['../create-account']"
          >
            Get Started
          </div>
        </div>
      </div>
      <div
        class="right"
        id="banner_img"
        data-aos="fade-right"
        data-aos-easing="ease-in-sine"
        data-aos-delay="100"
        data-aos-duration="400"
      >
        <img src="../../../../assets/icons/Circles-3.gif" alt="" />
      </div>
    </div>

    <div class="mouse_wheel_section">
      <span class="mouse">
        <span class="mouse__wheel"></span>
      </span>
    </div>
    <div class="all_services_section">
      <div
        class="services_section_header"
        data-aos="fade-up"
        data-aos-easing="ease-in-sine"
        data-aos-delay="200"
        data-aos-duration="1000"
      >
        Powering Business Growth
      </div>
      <div
        class="services_section_sub_header"
        data-aos="fade-up"
        data-aos-easing="ease-in-sine"
        data-aos-delay="200"
        data-aos-duration="1000"
      >
        Our well documented APIs allows you build everything from the simplest
        projects to the most complex ones. No wonder we are trusted by
        developers to power their business growth.
      </div>

      <div class="service_cards_1 wrap">
        <div
          class="card"
          data-aos="fade-left"
          data-aos-easing="ease-in-sine"
          data-aos-delay="400"
          data-aos-duration="1000"
        >
          <div class="card_logo">
            <img
              src="../../../../assets/icons/Bill-Payment (1).svg"
              alt="bill_pay"
            />
          </div>
          <div class="card_info">
            <div class="card_header">
              Bill Payment
            </div>
            <div class="card_details">
              Our Bill Payments Service provides functionalities for
              applications to expose bill payments capabilities to their users.
            </div>
            <div
              class="card_cta"
              [routerLink]="['../services']"
              fragment="bill"
            >
              <i class="fa fa-chevron-circle-right animated slideIn"></i>

              <span class="learn_text">Learn More</span>
            </div>
          </div>
        </div>

        <div
          class="card"
          data-aos="fade-left"
          data-aos-easing="ease-in-sine"
          data-aos-delay="400"
          data-aos-duration="1000"
        >
          <div class="card_logo">
            <img
              src="../../../../assets/icons/Loan Service.svg"
              alt="bill_pay"
            />
          </div>
          <div class="card_info">
            <div class="card_header">
              Loan Service
            </div>
            <div class="card_details">
              Seamlessly offer consumer loans through a simple process and 3rd
              party applications.
            </div>
            <div
              class="card_cta"
              [routerLink]="['../services']"
              fragment="loan"
            >
              <i class="fa fa-chevron-circle-right animated slideIn"></i>

              <span class="learn_text">Learn More</span>
            </div>
          </div>
        </div>

        <div
          class="card"
          data-aos="fade-right"
          data-aos-easing="ease-in-sine"
          data-aos-delay="400"
          data-aos-duration="1000"
        >
          <div class="card_logo">
            <img
              src="../../../../assets/icons/Disbursement.svg"
              alt="bill_pay"
            />
          </div>
          <div class="card_info">
            <div class="card_header">
              Disbursement Service
            </div>
            <div class="card_details">
              Eliminate many of the issues that currently plague your business
              to partner transactions.
            </div>
            <div
              class="card_cta"
              [routerLink]="['../services']"
              fragment="disburse"
            >
              <i class="fa fa-chevron-circle-right animated slideIn"></i>

              <span class="learn_text">Learn More</span>
            </div>
          </div>
        </div>

        <div
          class="card"
          #collection
          id="collection"
          data-aos="fade-right"
          data-aos-easing="ease-in-sine"
          data-aos-delay="400"
          data-aos-duration="1000"
        >
          <div class="card_logo">
            <img src="../../../../assets/images/money.svg" alt="bill_pay" />
          </div>
          <div class="card_info">
            <div class="card_header">
              Collection Service
            </div>
            <div class="card_details">
              Eliminate many of the issues that currently plague your business
              collection needs with our seamless integration.
            </div>
            <div
              class="card_cta"
              [routerLink]="['../services']"
              fragment="collection"
            >
              <i class="fa fa-chevron-circle-right animated slideIn"></i>

              <span class="learn_text">Learn More</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="pink_section_area">
      <div class="services_section_header">
        What You Get
      </div>
      <div class="content">
        <div class="left">
          <img src="../../../../assets/images/untitled-project@2x.png" alt="" />
        </div>

        <div class="right">
          <div
            class="right_header"
            data-aos="fade-in"
            data-aos-easing="ease-in-sine"
            data-aos-delay="200"
            data-aos-duration="1000"
          >
            Simplified Business management through a feature-rich centralized
            platform
          </div>

          <div class="arrowed_list">
            <div class="arrowed" data-aos="fade-down" data-aos-easing="linear">
              <i class="fa fa-chevron-circle-right"> </i>
              <span class="arrowed_text"> Manage Multiple Businesses </span>
            </div>
            <div class="arrowed" data-aos="fade-down" data-aos-easing="linear">
              <i
                class="fa fa-chevron-circle-right"
                data-aos="fade-down"
                data-aos-easing="linear"
              >
              </i>
              <span class="arrowed_text"> Swift API Integration</span>
            </div>
            <div class="arrowed" data-aos="fade-up" data-aos-easing="linear">
              <i class="fa fa-chevron-circle-right"> </i>
              <span class="arrowed_text"> Advanced API Key Security</span>
            </div>
            <div class="arrowed" data-aos="fade-up" data-aos-easing="linear">
              <i class="fa fa-chevron-circle-right"> </i>
              <span class="arrowed_text"> Well Documented APIs </span>
            </div>
            <div class="arrowed" data-aos="fade-up" data-aos-easing="linear">
              <i class="fa fa-chevron-circle-right"> </i>
              <span class="arrowed_text">Centralized Team Management </span>
            </div>
            <div class="get_started" [routerLink]="['../create-account']">
              Get Started
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="trustees_section" data-aos="fade-down" data-aos-easing="linear">
      <div class="trustees_text">
        <div class="text_header" data-aos="fade-in" data-aos-easing="linear">
          A Team Trusted By Brands Across Africa
        </div>
        <div class="sub_text">
          At Global Accelerex, we are driven by the aim of delivering innovative
          technology solutions in a secure and reliable manner to businesses and
          consumers across channels. We are trusted by reputable brands to
          deliver on this promise and a lot more.
        </div>
      </div>

      <div class="trustees_logos" data-aos="fade-in" data-aos-easing="linear">
        <img src="../../../../assets/images/ChIpperCash.png" alt="" />
        <img src="../../../../assets/images/seamlesshr.png" alt="" />
        <img
          src="../../../../assets/images/Fidelity Bank Logo.png"
          alt=""
          style="width: 5.5rem;"
        />
        <img src="../../../../assets/images/Ecobank logo.png" alt="" />
      </div>
    </div>
    <app-footer></app-footer>
  </div>
</div>
